export default __webpack_public_path__ + "static/media/Merchant.da921112.png";